/**
 * This file is included and used only by the login page.
 *
 *
 */

let loginForm = document.getElementById("loginform");

loginForm.addEventListener("submit", (e) => {
  e.preventDefault();
  new FormData(loginForm);
});

loginForm.addEventListener("formdata", async (e) => {
  const loginFormObj = Object.fromEntries(e.formData.entries());

  if (!loginFormObj.username) {
    document.getElementsByName("username")[0].focus();
    return;
  }
  if (!loginFormObj.password) {
    document.getElementsByName("password")[0].focus();
    return;
  }

  const submitBtn = document.querySelector("#loginform button[type='submit']");

  submitBtn.disabled = true;
  submitBtn.classList.add("spin");
  submitBtn.classList.add("fa-refresh");
  submitBtn.classList.remove("fa-check");
  try {
    const response = await fetch("/auth/customer/login", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(loginFormObj)
    });

    if (!response.ok) {
      throw new Error("Die Antwort des Servers ist fehlerhaft.");
    }

    let data = loginForm.querySelector("[name=queryStr]").value;

    location.href = "/anmeldung#" + data;
  } catch (error) {
    console.error("Error in addEventListener('formdata)", error);

    let loginError = document.getElementById("loginError");
    loginError.classList.remove("hide");
  } finally {
    submitBtn.classList.remove("spin");
    submitBtn.classList.remove("fa-refresh");
    submitBtn.classList.add("fa-check");
    submitBtn.disabled = false;
  }
});

async function checkLoggedIn() {
  try {
    const response = await fetch("/api/v1/me", {
      headers: {
        "Content-Type": "application/json"
      }
    });
    const me = await response.json();

    if (me.username) {
      let loggedInButton = document.querySelector(
        "#loginform .button[href='/anmeldung']"
      );
      loggedInButton.textContent = `Direkt weiter als ${me.username}`;
      if (!me.isCustomer) {
        loggedInButton.href = "/dispo";
      }
      loggedInButton.classList.remove("hide");
      let loginFormInputs = document.querySelectorAll("#loginform input");
      loginFormInputs.forEach((x) => {
        x.classList.add("disabled");
        x.disabled = true;
      });
      let loginButton = document.querySelector(
        "#loginform .button[type='submit']"
      );
      loginButton.classList.add("hide");
    }
  } catch (error) {
    console.error("Error in checkLoggedIn()", error);
  }
}
checkLoggedIn();

function checkAutoLogin() {
  const urlSearchParams = new URLSearchParams(window.location.hash.substr(1));
  let username = urlSearchParams.get("username");
  let password = urlSearchParams.get("password");
  loginForm.querySelector("[name=username]").value = username;
  loginForm.querySelector("[name=password]").value = password;

  // remove data from hash
  window.location.hash = "";
  urlSearchParams.delete("username");
  urlSearchParams.delete("password");
  // and preserve it for transmitting further
  loginForm.querySelector("[name=queryStr]").value = urlSearchParams.toString();

  // submit the form
  if (username && password) {
    new FormData(loginForm);
  }
}

window.addEventListener("load", () => {
  checkAutoLogin();
});
